$(document).ready(function () {
  $("[data-form-prepend]").click(function (event) {
    var obj = $($(this).attr("data-form-prepend"));
    var tag = new Date().getTime();

    obj.find("input, select, textarea").each(function () {
      $(this).attr("name", function () {
        return $(this).attr("name").replace("new_record", tag);
      });
    });

    obj.find("input, select, textarea").each(function () {
      if ($(this).attr("id") != null) {
        $(this).attr("id", function () {
          return $(this).attr("id").replace("new_record", tag);
        });
      }
    });

    if ($(this).attr("data-append-point")) {
      var appendElement = $($(this).attr("data-append-point"));
      obj.appendTo(appendElement);
    } else {
      obj.insertBefore(this);
    }
    return false;
  });

  $(document).on("click", "[data-form-delete]", function (event) {
    var elementTag = $(this).attr("data-form-delete");
    if (elementTag) {
      var element = $(this).closest(elementTag);
      if (element) {
        element.remove();
      }
    }
    return false;
  });
});
